import { useEffect, useMemo, useState } from "react";
import axios from "axios";

const API =
  process.env.REACT_APP_API_URL ||
  "https://homefoods-backend-production.up.railway.app/api";

function useBakery() {
  const [products, setProducts] = useState([]);

  const [loading, setLoading] = useState(true);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("All");

  const [selectedProduct, setSelectedProduct] = useState(null);

  const [showForm, setShowForm] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      const res = await axios.get(
        `${API}/bakery/my-products`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setProducts(res.data.products || []);
      console.log("Products:", res.data.products);
    } catch (err) {
      console.error("Fetch Products Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const filteredProducts = useMemo(() => {
    return products.filter((item) => {
      const matchSearch =
        item.productName
          ?.toLowerCase()
          .includes(search.toLowerCase());

      const matchCategory =
        category === "All" ||
        item.category === category;

      return matchSearch && matchCategory;
    });
  }, [products, search, category]);

  // ===========================
  // Modal Functions
  // ===========================

  const openAddModal = () => {
    setSelectedProduct(null);
    setShowForm(true);
  };

  const openEditModal = (product) => {
    setSelectedProduct(product);
    setShowForm(true);
  };

  const openDetails = (product) => {
    setSelectedProduct(product);
    setShowDetails(true);
  };

  const openDeleteModal = (product) => {
    setSelectedProduct(product);
    setShowDelete(true);
  };

  const closeForm = () => {
    setShowForm(false);
    setSelectedProduct(null);
  };

  const closeDetails = () => {
    setShowDetails(false);
    setSelectedProduct(null);
  };

  const closeDelete = () => {
    setShowDelete(false);
    setSelectedProduct(null);
  };

  // ===========================
  // Delete Product
  // ===========================

  const deleteProduct = async () => {
    if (!selectedProduct) return;

    try {
      setDeleteLoading(true);

      const token = localStorage.getItem("token");

      await axios.delete(
        `${API}/bakery/${selectedProduct._id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      await fetchProducts();

      closeDelete();

    } catch (err) {
      console.error("Delete Product Error:", err);
    } finally {
      setDeleteLoading(false);
    }
  };

  return {
    // Products
    products,
    filteredProducts,

    // Loading
    loading,
    deleteLoading,

    // Search & Filter
    search,
    setSearch,

    category,
    setCategory,

    // Selected Product
    selectedProduct,
    setSelectedProduct,

    // Modal States
    showForm,
    showDetails,
    showDelete,

    // Fetch
    fetchProducts,

    // Modal Actions
    openAddModal,
    openEditModal,
    openDetails,
    openDeleteModal,

    closeForm,
    closeDetails,
    closeDelete,

    // CRUD
    deleteProduct,
  };
}

export default useBakery;